"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var geometry_1 = tslib_1.__importDefault(require("./geometry"));
var preRenderResponsive = [{ name: 'responsiveRing', method: geometry_1.default }];
var afterRenderResponsive = [];
exports.default = {
    preRender: preRenderResponsive,
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/ring/apply-responsive/index.js
// module id = 963
// module chunks = 37